import React from 'react';
import { useLocation } from 'react-router-dom';

import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

import { isDisableNavigationOn } from '@common/Util.jsx';
import Footer from '@components/AppFooter/Footer';
import Header from '@components/AppHeader/Header';
import stylesConfig from '@config/styles.config.json';
import useInterceptors from '@hooks/Interceptors/useInterceptors';

const StyledBox = styled(Box)(({ theme }) => ({
  padding: 0,
  background: theme.palette.background.primary,
  paddingBottom: '5rem',
  [theme.breakpoints.up('md')]: {
    paddingBottom: 'inherit'
  }
}));

const AppContainer = ({ rest, Component, headerConfig }) => {
  const location = useLocation();
  const customConfig = stylesConfig?.mea;

  const disableComponent = isDisableNavigationOn(location);

  // TODO - move adding of auth headers to base api file and remove interceptors if centralized error handling is not necessary
  useInterceptors();

  return (
    <StyledBox>
      <Header
        config={customConfig}
        disableComponent={disableComponent}
        headerConfig={headerConfig}
      />
      <Component {...rest} configuration={customConfig} />
      <Footer disableComponent={disableComponent} />
    </StyledBox>
  );
};

export default AppContainer;
